import { routing } from "../../routing.js";
import { SortOrder } from "../../types/index.js";
export function createClient(api) {
  /**
   * List Contacts Exports with sorting, and pagination.
   */
  async function list(options = {}) {
    const {
      limit,
      offset,
      search,
      sortOrder
    } = options;
    const {
      contacts,
      pagination,
      sort
    } = await api.get(routing.contactsUrl, {
      query: {
        search,
        limit,
        offset,
        sort: SortOrder.stringify(sortOrder)
      }
    });
    return {
      contacts,
      pagination,
      sortOrder: SortOrder.parse(sort)
    };
  }

  /**
   * List Contacts Exports with sorting, pagination, and filtering.
   */
  async function search(options = {}) {
    const {
      limit,
      offset,
      query,
      search,
      sortOrder
    } = options;
    const url = `${routing.contactsUrl}/search`;
    const {
      contacts,
      pagination,
      sort
    } = await api.post(url, {
      payload: {
        limit,
        offset,
        search,
        sort: SortOrder.stringify(sortOrder),
        query
      }
    });
    return {
      contacts,
      pagination,
      sortOrder: SortOrder.parse(sort)
    };
  }
  async function get(id) {
    const url = `${routing.contactsUrl}/${id}`;
    const {
      contact
    } = await api.get(url);
    return contact;
  }
  async function getMany(ids) {
    const {
      contacts
    } = await search({
      query: {
        id: {
          $in: ids
        }
      },
      limit: ids.length
    });
    // Reorder results to match the order of `ids`.
    return contacts.sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));
  }
  async function create(payload) {
    const {
      contact
    } = await api.post(routing.contactsUrl, {
      payload
    });
    return contact;
  }
  async function update(id, payload) {
    const url = `${routing.contactsUrl}/${id}`;
    const {
      contact
    } = await api.patch(url, {
      payload
    });
    return contact;
  }
  async function tag(id, tags) {
    const url = `${routing.contactsUrl}/${id}`;
    const {
      contact
    } = await api.patch(url, {
      payload: {
        '+tags': tags
      }
    });
    return contact;
  }
  async function untag(id, tags) {
    const url = `${routing.contactsUrl}/${id}`;
    const {
      contact
    } = await api.patch(url, {
      payload: {
        '-tags': tags
      }
    });
    return contact;
  }
  function bulkTag(selector, tags) {
    const {
      scope,
      query
    } = selector;
    return api.patch(routing.contactsUrl, {
      payload: {
        query,
        scope,
        '+tags': tags
      }
    });
  }
  function bulkUntag(selector, tags) {
    const {
      query,
      scope
    } = selector;
    return api.patch(routing.contactsUrl, {
      payload: {
        query,
        scope,
        '-tags': tags
      }
    });
  }
  async function doDelete(id) {
    const url = `${routing.contactsUrl}/${id}`;
    await api.delete(url);
  }
  async function bulkDelete(selector) {
    const {
      query,
      scope
    } = selector;
    return api.delete(routing.contactsUrl, {
      payload: {
        query,
        scope
      }
    });
  }
  return {
    list,
    search,
    get,
    getMany,
    create,
    update,
    tag,
    untag,
    bulkTag,
    bulkUntag,
    delete: doDelete,
    bulkDelete
  };
}